module.exports = __webpack_public_path__ + "static/media/patrol(13).1f9cac06.PNG";